import { SpeechBubbleIcon } from "@remo-co/ui-core/src/icons/SpeechBubble";
import { isWithinSupportHours } from "helpers/time/supportHours";
import AuthButton from "modules/auth/authButtons/AuthButton";
import { useCallback, useContext, useMemo } from "react";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { useI18n } from "i18n";
import {
  selectDisableFreshchatWidget,
  selectEnableAgencyWhiteLabelling,
} from "modules/settings/redux/selectors";
import { useSelector } from "react-redux";
import { useStyles } from "./styles";
import { useNeedHelp } from "../../hooks";

interface Props {
  className?: string;
}

export const NeedHelpChatButton = ({ className }: Props) => {
  const { t } = useI18n(["common"]);
  const { track } = useContext(TRACKING_CONTEXT);
  const { callApi } = useNeedHelp();
  const enableAgencyWhiteLabelling = useSelector(
    selectEnableAgencyWhiteLabelling,
  );
  const disableFreshchatWidget = useSelector(selectDisableFreshchatWidget);
  const styles = useStyles();
  const showChatSupportButton = useMemo(() => isWithinSupportHours(), []);

  const showHelpChatWindow = useCallback(() => {
    callApi("showNewMessage");
    track(Events.LOGIN_CHAT_SUPPORT_CLICKED);
  }, [callApi, track]);

  if (
    !showChatSupportButton ||
    (enableAgencyWhiteLabelling && disableFreshchatWidget)
  ) {
    return null;
  }

  return (
    <AuthButton
      aria-label={t("auth:login.with.anonymous")}
      onClick={showHelpChatWindow}
      startAdornment={<SpeechBubbleIcon className={styles.icon} />}
      color="dark"
      data-testid="chat-support-button"
      className={className}
      variant="special"
      contentWrapperClassName={styles.content}
    >
      {t("common:need.help.logging.in")}
    </AuthButton>
  );
};
